// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__41R_J","header":"PatientQuestionnaire_header__4Fu5M","info":"PatientQuestionnaire_info__3186M"};